"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __spreadArray = (this && this.__spreadArray) || function (to, from) {
    for (var i = 0, il = from.length, j = to.length; i < il; i++, j++)
        to[j] = from[i];
    return to;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.presentSnippet = exports.initProxy = void 0;
require("proxy-polyfill");
var snippet_1 = require("./snippet");
// eslint-disable-next-line no-extend-native
String.prototype.interpolate = function (params) {
    var names = Object.keys(params);
    var vals = Object.values(params);
    // eslint-disable-next-line no-new-func
    return new (Function.bind.apply(Function, __spreadArray(__spreadArray([void 0], names), ["return `" + this + "`;"])))().apply(void 0, vals);
};
var prepareSnippet = function (snippetString, templates) {
    var s = snippetString.interpolate(templates);
    s = '!(' + s + ')();';
    return s;
};
// eslint-disable-next-line @typescript-eslint/ban-types
var hasProp = function (target, prop) { return prop in target; };
var initProxy = function () {
    var _a;
    if (window.CommandBar === undefined || window.CommandBar._disposed === true) {
        // @ts-expect-error: Temporarily ignore CommandBarProxy definition
        var existingQueue = Array.isArray((_a = window.CommandBar) === null || _a === void 0 ? void 0 : _a.q) ? __spreadArray([], window.CommandBar.q) : [];
        existingQueue = existingQueue.filter(function (item) {
            return item.length > 0 && item[0] !== 'dispose';
        });
        var cb_1 = {
            q: existingQueue,
        };
        window.CommandBar = new Proxy(cb_1, {
            get: function (_, prop) {
                if (hasProp(cb_1, prop))
                    return cb_1[prop];
                return function () {
                    // eslint-disable-next-line prefer-rest-params
                    var a = Array.prototype.slice.call(arguments);
                    a.unshift(prop);
                    cb_1.q.push(a);
                };
            },
        });
    }
    return window.CommandBar;
};
exports.initProxy = initProxy;
var getSrc = function (org, version) {
    var origin = 'https://api.commandbar.com';
    var params = [];
    var lc = localStorage.getItem('commandbar.lc');
    if (lc && lc.includes('local')) {
        // for debugging purposes
        origin = 'http://localhost:8000';
    }
    var src = origin + '/latest/' + org;
    if (lc) {
        params.push('lc=' + lc);
    }
    if (!!version) {
        params.push('v=' + version);
    }
    src = src + '?' + params.join('&');
    return src;
};
// eslint-disable-next-line @typescript-eslint/no-empty-function
var loadOrg = function () { };
var loadLatest = function (org) {
    var src = getSrc(org);
    var el = document.createElement('script');
    el.type = 'text/javascript';
    el.async = true;
    el.src = src;
    document.head.appendChild(el);
    window.removeEventListener('load', loadOrg, false);
};
var DEFAULT_OPTS = { debug: false, version: '' };
var init = function (org, opts) {
    if (opts === void 0) { opts = DEFAULT_OPTS; }
    var config = __assign(__assign({}, DEFAULT_OPTS), opts);
    if (!org) {
        console.error('No org specified for CommandBar.init');
        return;
    }
    config.debug && console.log('CommandBar init...');
    exports.initProxy();
    loadOrg = function () { return loadLatest(org); };
    window.addEventListener('load', loadOrg, false);
};
var presentSnippet = function (org) {
    var snippetString = prepareSnippet(snippet_1.snippet.toString(), { org: org, version: '' });
    var trimmedSnippet = snippetString
        .split('\n')
        .map(function (line) {
        return line.trim();
    })
        .join('');
    return "<script>\n  " + trimmedSnippet + "\n</script>";
};
exports.presentSnippet = presentSnippet;
exports.default = init;
//# sourceMappingURL=init.js.map